{
  "#KUNDENANLAGE": {
    "TITLE": "Kundenanmeldung"
  }
}
